import { useState, useEffect } from 'react';
import { supabase } from './supabase';

function getDeviceInfo() {
  const ua = navigator.userAgent;
  let browser = 'Navigateur';
  let os = 'Inconnu';
  if (ua.includes('Chrome')) browser = 'Chrome';
  else if (ua.includes('Safari')) browser = 'Safari';
  else if (ua.includes('Firefox')) browser = 'Firefox';
  if (ua.includes('Mac')) os = 'Mac';
  else if (ua.includes('iPhone')) os = 'iPhone';
  else if (ua.includes('Android')) os = 'Android';
  else if (ua.includes('Windows')) os = 'Windows';
  return `${browser} — ${os}`;
}

export default function SettingsPage({ user, profile, onClose, onProfileUpdate }) {
  const [activeSection, setActiveSection] = useState('profil');
  const [username, setUsername] = useState(profile?.username || '');
  const [usernameMsg, setUsernameMsg] = useState('');
  const [usernameLoading, setUsernameLoading] = useState(false);
  const [newPwd, setNewPwd] = useState('');
  const [confirmPwd, setConfirmPwd] = useState('');
  const [pwdMsg, setPwdMsg] = useState('');
  const [pwdLoading, setPwdLoading] = useState(false);
  const [sessions, setSessions] = useState([]);
  const [sessionsLoading, setSessionsLoading] = useState(false);
  const [simBalance, setSimBalance] = useState(() => parseFloat(localStorage.getItem('sim-wallet-balance') || '10'));
  const [simInput, setSimInput] = useState('');
  const [simMsg, setSimMsg] = useState('');
  const [simAmountInput, setSimAmountInput] = useState(() => localStorage.getItem('sim-trade-amount') || '');
  const [tgToken, setTgToken] = useState(profile?.telegram_token || '');
  const [tgChatId, setTgChatId] = useState(profile?.telegram_chat_id || '');
  const [tgMsg, setTgMsg] = useState('');
  const [tgLoading, setTgLoading] = useState(false);

  useEffect(() => {
    if (activeSection === 'securite') fetchSessions();
  }, [activeSection]);

  const fetchSessions = async () => {
    setSessionsLoading(true);
    const { data: { session } } = await supabase.auth.getSession();
    if (session) {
      setSessions([{
        id: session.access_token?.slice(0, 8),
        device: getDeviceInfo(),
        created_at: new Date().toISOString(),
        current: true,
      }]);
    }
    setSessionsLoading(false);
  };

  const handleSaveUsername = async () => {
    if (!username.trim()) return setUsernameMsg('Nom requis');
    setUsernameLoading(true);
    const { error } = await supabase.from('profiles').update({ username: username.trim() }).eq('id', user.id);
    if (error) setUsernameMsg('' + error.message);
    else {
      setUsernameMsg('Nom mis à jour !');
      if (onProfileUpdate) onProfileUpdate();
      setTimeout(() => setUsernameMsg(''), 3000);
    }
    setUsernameLoading(false);
  };

  const handleChangePwd = async () => {
    if (!newPwd || newPwd.length < 6) return setPwdMsg('Min 6 caractères');
    if (newPwd !== confirmPwd) return setPwdMsg('Mots de passe différents');
    setPwdLoading(true);
    const { error } = await supabase.auth.updateUser({ password: newPwd });
    if (error) setPwdMsg('' + error.message);
    else {
      setPwdMsg('Mot de passe changé !');
      setNewPwd(''); setConfirmPwd('');
      setTimeout(() => setPwdMsg(''), 3000);
    }
    setPwdLoading(false);
  };

  const handleSignOutAll = async () => {
    if (!window.confirm('Déconnecter tous les appareils ?')) return;
    await supabase.auth.signOut({ scope: 'global'});
  };

  const handleResetSim = () => {
    if (!simInput) return setSimMsg('Entre un montant d\'abord');
    const bal = parseFloat(simInput);
    if (isNaN(bal) || bal <= 0) return setSimMsg('Montant invalide');
    localStorage.setItem('sim-wallet-balance', String(bal));
    setSimBalance(bal);
    setSimInput('');
    setSimMsg('Solde sim réinitialisé à '+ bal + 'SOL');
    setTimeout(() => setSimMsg(''), 3000);
  };

  const handleClearSimHistory = () => {
    if (!window.confirm('Effacer tout l\'historique sim ? Irréversible.')) return;
    const trades = JSON.parse(localStorage.getItem('bot-trades') || '[]');
    localStorage.setItem('bot-trades', JSON.stringify(trades.filter(t => !t.isSim)));
    localStorage.removeItem('sim-bot-trades');
    setSimMsg('Historique sim effacé');
    setTimeout(() => setSimMsg(''), 3000);
  };

  const handleSaveTelegram = async () => {
    if (!tgToken || !tgChatId) return setTgMsg('Token et Chat ID requis');
    const { error } = await supabase.from('profiles')
      .update({ telegram_token: tgToken.trim(), telegram_chat_id: tgChatId.trim() })
      .eq('id', user.id);
    if (error) { setTgMsg('' + error.message); return; }
    if (onProfileUpdate) onProfileUpdate();
    setTgMsg('Telegram configuré !');
    setTimeout(() => setTgMsg(''), 3000);
  };

  const handleTestTelegram = async () => {
    setTgLoading(true);
    try {
      const r = await fetch(`https://api.telegram.org/bot${tgToken}/sendMessage`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json'},
        body: JSON.stringify({ chat_id: tgChatId, text: 'COPYCCXX — Test de connexion réussi !', parse_mode: 'HTML'}),
      });
      const j = await r.json();
      if (j.ok) setTgMsg('Message envoyé !');
      else setTgMsg('' + j.description);
    } catch(e) { setTgMsg('' + e.message); }
    setTgLoading(false);
    setTimeout(() => setTgMsg(''), 4000);
  };

  const sections = [
    { id: 'profil', icon: '', label: 'Profil'},
    { id: 'securite', icon: '', label: 'Sécurité'},
    { id: 'paper', icon: '', label: 'Paper Trading'},
    { id: 'telegram', icon: '', label: 'Notifications'},
  ];

  const inp = { background:'#0d1117', border:'1px solid #1e2a38', borderRadius:6, color:'#c0c8d8', fontSize:13, padding:'10px 14px', width:'100%', outline:'none', boxSizing:'border-box'};

  return (
    <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.85)',backdropFilter:'blur(8px)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}}>
      <div style={{background:'#0b0e14',border:'1px solid rgba(0,229,204,0.2)',borderRadius:12,width:620,maxHeight:'85vh',display:'flex',flexDirection:'column',overflow:'hidden',boxShadow:'0 20px 60px rgba(0,0,0,0.8)'}}>

        {/* Header */}
        <div style={{padding:'16px 20px',borderBottom:'1px solid #1a2030',display:'flex',alignItems:'center',justifyContent:'space-between',flexShrink:0}}>
          <div>
            <div style={{fontSize:15,fontWeight:800,color:'#e0e8f0'}}> Paramètres</div>
            <div style={{fontSize:11,color:'#3a4a5a',marginTop:2}}>{user?.email}</div>
          </div>
          <button onClick={onClose} style={{background:'none',border:'none',color:'#5a6a80',cursor:'pointer',fontSize:22,lineHeight:1}}>×</button>
        </div>

        <div style={{display:'flex',flex:1,overflow:'hidden'}}>
          {/* Sidebar */}
          <div style={{width:160,borderRight:'1px solid #1a2030',padding:'12px 8px',flexShrink:0}}>
            {sections.map(s=>(
              <button key={s.id} onClick={()=>setActiveSection(s.id)}
                style={{width:'100%',padding:'10px 12px',borderRadius:8,background:activeSection===s.id?'rgba(0,229,204,0.08)':'transparent',border:`1px solid ${activeSection===s.id?'#00e5cc22':'transparent'}`,color:activeSection===s.id?'#00e5cc':'#5a6a80',fontSize:12,fontWeight:activeSection===s.id?700:400,cursor:'pointer',display:'flex',alignItems:'center',gap:8,marginBottom:4,textAlign:'left'}}>
                <span style={{fontSize:14}}>{s.icon}</span>
                <span>{s.label}</span>
              </button>
            ))}
          </div>

          {/* Content */}
          <div style={{flex:1,overflowY:'auto',padding:'20px'}}>

            {/*  PROFIL  */}
            {activeSection==='profil'&&(
              <div style={{display:'flex',flexDirection:'column',gap:16}}>
                <div style={{fontSize:13,fontWeight:700,color:'#e0e8f0',marginBottom:4}}> Mon Profil</div>
                <div style={{display:'flex',alignItems:'center',gap:16,padding:'16px',background:'rgba(0,229,204,0.04)',border:'1px solid #00e5cc11',borderRadius:10}}>
                  <div style={{width:56,height:56,borderRadius:'50%',background:'linear-gradient(135deg,#00e5cc,#7c4dff)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:22,fontWeight:800,color:'#060809',flexShrink:0}}>
                    {(profile?.username||user?.email)?.charAt(0).toUpperCase()}
                  </div>
                  <div>
                    <div style={{fontSize:13,fontWeight:700,color:'#e0e8f0'}}>{profile?.username||'Sans nom'}</div>
                    <div style={{fontSize:11,color:'#5a6a80',marginTop:2}}>{user?.email}</div>
                    <div style={{display:'flex',gap:6,marginTop:6}}>
                      {profile?.is_admin&&<span style={{fontSize:9,padding:'2px 7px',borderRadius:8,background:'rgba(124,77,255,0.15)',color:'#7c4dff',border:'1px solid #7c4dff33',fontWeight:700}}> ADMIN</span>}
                      <span style={{fontSize:9,padding:'2px 7px',borderRadius:8,background:'rgba(0,229,204,0.1)',color:'#00e5cc',border:'1px solid #00e5cc22',fontWeight:700}}> Actif</span>
                    </div>
                  </div>
                </div>
                <div>
                  <div style={{fontSize:10,color:'#5a6a80',marginBottom:6,letterSpacing:'0.8px'}}>NOM D'UTILISATEUR</div>
                  <div style={{display:'flex',gap:8}}>
                    <input style={{...inp,flex:1}} placeholder="Ton nom d'utilisateur..."value={username} onChange={e=>setUsername(e.target.value)}/>
                    <button onClick={handleSaveUsername} disabled={usernameLoading}
                      style={{padding:'10px 16px',borderRadius:6,background:'rgba(0,229,204,0.15)',border:'1px solid #00e5cc33',color:'#00e5cc',fontSize:12,fontWeight:700,cursor:'pointer',flexShrink:0}}>
                      {usernameLoading?'⏳':'Sauvegarder'}
                    </button>
                  </div>
                  {usernameMsg&&<div style={{fontSize:11,color:usernameMsg.startsWith('')?'#00e5cc':'#ff6b6b',marginTop:6}}>{usernameMsg}</div>}
                </div>
                <div>
                  <div style={{fontSize:10,color:'#5a6a80',marginBottom:6,letterSpacing:'0.8px'}}>EMAIL</div>
                  <input style={{...inp,opacity:0.6,cursor:'not-allowed'}} value={user?.email||''} disabled/>
                  <div style={{fontSize:10,color:'#2a3a4a',marginTop:4}}>L'email ne peut pas être modifié</div>
                </div>
                <div style={{padding:'12px 14px',background:'#0d1117',border:'1px solid #1a2030',borderRadius:8}}>
                  <div style={{fontSize:10,color:'#3a4a5a',marginBottom:4}}>MEMBRE DEPUIS</div>
                  <div style={{fontSize:12,color:'#c0c8d8',fontWeight:600}}>
                    {user?.created_at ? new Date(user.created_at).toLocaleDateString('fr-FR', {day:'numeric',month:'long',year:'numeric'}) : '—'}
                  </div>
                </div>
              </div>
            )}{/*  SÉCURITÉ  */}
            {activeSection==='securite'&&(
              <div style={{display:'flex',flexDirection:'column',gap:16}}>
                <div style={{fontSize:13,fontWeight:700,color:'#e0e8f0',marginBottom:4}}> Sécurité</div>
                <div style={{padding:'16px',background:'#0d1117',border:'1px solid #1a2030',borderRadius:10}}>
                  <div style={{fontSize:12,fontWeight:700,color:'#c0c8d8',marginBottom:12}}>Changer le mot de passe</div>
                  <div style={{display:'flex',flexDirection:'column',gap:8}}>
                    <input style={inp} type="password"placeholder="Nouveau mot de passe"value={newPwd} onChange={e=>setNewPwd(e.target.value)}/>
                    <input style={inp} type="password"placeholder="Confirmer le mot de passe"value={confirmPwd} onChange={e=>setConfirmPwd(e.target.value)}/>
                    {pwdMsg&&<div style={{fontSize:11,color:pwdMsg.startsWith('')?'#00e5cc':'#ff6b6b'}}>{pwdMsg}</div>}
                    <button onClick={handleChangePwd} disabled={pwdLoading||!newPwd||!confirmPwd}
                      style={{padding:'10px',borderRadius:6,background:'rgba(0,229,204,0.15)',border:'1px solid #00e5cc33',color:'#00e5cc',fontSize:12,fontWeight:700,cursor:'pointer',opacity:!newPwd||!confirmPwd?0.5:1}}>
                      {pwdLoading?'⏳ Changement...':'Changer le mot de passe'}
                    </button>
                  </div>
                </div>
                <div style={{padding:'16px',background:'#0d1117',border:'1px solid #1a2030',borderRadius:10}}>
                  <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:12}}>
                    <div style={{fontSize:12,fontWeight:700,color:'#c0c8d8'}}> Sessions actives</div>
                    <button onClick={handleSignOutAll}
                      style={{padding:'5px 10px',borderRadius:6,background:'rgba(255,107,107,0.1)',border:'1px solid #ff6b6b22',color:'#ff6b6b',fontSize:10,fontWeight:700,cursor:'pointer'}}>
                      Déconnecter tout
                    </button>
                  </div>
                  {sessionsLoading?(
                    <div style={{fontSize:11,color:'#3a4a5a',textAlign:'center',padding:20}}>Chargement...</div>
                  ):sessions.map((s,i)=>(
                    <div key={i} style={{padding:'10px 12px',background:'rgba(0,229,204,0.04)',border:'1px solid #00e5cc11',borderRadius:8,display:'flex',alignItems:'center',gap:12}}>
                      <span style={{fontSize:20}}></span>
                      <div style={{flex:1}}>
                        <div style={{fontSize:11,fontWeight:700,color:'#c0c8d8'}}>{s.device}</div>
                        <div style={{fontSize:10,color:'#3a4a5a',marginTop:2}}>Session actuelle</div>
                      </div>
                      {s.current&&<span style={{fontSize:9,padding:'2px 8px',borderRadius:8,background:'rgba(0,229,204,0.15)',color:'#00e5cc',border:'1px solid #00e5cc33',fontWeight:700}}>ACTIF</span>}
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/*  PAPER TRADING  */}
            {activeSection==='paper'&&(
              <div style={{display:'flex',flexDirection:'column',gap:16}}>
                <div style={{fontSize:13,fontWeight:700,color:'#e0e8f0',marginBottom:4}}> Paper Trading</div>

                {/* Solde actuel */}
                <div style={{padding:'16px',background:'linear-gradient(135deg,rgba(124,77,255,0.08),rgba(124,77,255,0.04))',border:'1px solid #7c4dff22',borderRadius:10,textAlign:'center'}}>
                  <div style={{fontSize:11,color:'#7c4dff',marginBottom:6,letterSpacing:'0.8px'}}>SOLDE SIM ACTUEL</div>
                  <div style={{fontSize:32,fontWeight:800,color:'#7c4dff',fontFamily:'monospace'}}>{simBalance.toFixed(4)}</div>
                  <div style={{fontSize:11,color:'#5a6a80',marginTop:4}}>SOL simulés</div>
                </div>

                {/*  Modifier solde — Admin seulement */}
                {profile?.is_admin && (
                  <div style={{padding:'16px',background:'#0d1117',border:'1px solid #1a2030',borderRadius:10}}>
                    <div style={{fontSize:12,fontWeight:700,color:'#c0c8d8',marginBottom:12}}>Modifier le solde <span style={{fontSize:9,padding:'2px 7px',borderRadius:4,background:'rgba(124,77,255,0.15)',color:'#7c4dff',border:'1px solid #7c4dff33',marginLeft:6}}>ADMIN</span></div>
                    <div style={{display:'flex',gap:6,marginBottom:8,flexWrap:'wrap'}}>
                      {['10','50','100','500','1000'].map(v=>(
                        <button key={v} onClick={()=>{localStorage.setItem('sim-wallet-balance',v);setSimBalance(parseFloat(v));setSimMsg('Solde défini à '+v+'SOL');setTimeout(()=>setSimMsg(''),3000);}}
                          style={{padding:'6px 12px',borderRadius:6,background:'rgba(124,77,255,0.1)',border:'1px solid #7c4dff22',color:'#7c4dff',fontSize:11,fontWeight:700,cursor:'pointer'}}>
                          {v} SOL
                        </button>
                      ))}
                    </div>
                    <div style={{display:'flex',gap:8}}>
                      <input type="number"placeholder="Montant personnalisé (SOL)"value={simInput} onChange={e=>setSimInput(e.target.value)}
                        style={{...inp,flex:1}} onKeyDown={e=>e.key==='Enter'&&handleResetSim()}/>
                      <button onClick={handleResetSim}
                        style={{padding:'10px 16px',borderRadius:6,background:'rgba(124,77,255,0.15)',border:'1px solid #7c4dff33',color:'#7c4dff',fontSize:12,fontWeight:700,cursor:'pointer',flexShrink:0}}>
                        Définir
                      </button>
                    </div>
                    {simMsg&&<div style={{fontSize:11,color:simMsg.startsWith('')?'#00e5cc':'#ff6b6b',marginTop:8}}>{simMsg}</div>}
                  </div>
                )}

                {/* Info pour les users normaux */}
                {!profile?.is_admin && (
                  <div style={{padding:'14px',background:'rgba(124,77,255,0.04)',border:'1px solid #7c4dff11',borderRadius:10}}>
                    <div style={{fontSize:11,color:'#7c4dff',fontWeight:700,marginBottom:4}}> Solde géré par l'administrateur</div>
                    <div style={{fontSize:11,color:'#5a6a80',lineHeight:1.6}}>Ton solde de simulation est défini par l'administrateur lors de l'activation de ton compte.</div>
                  </div>
                )}

                {/* Montant simulé par trade */}
                <div style={{padding:'16px',background:'#0d1117',border:'1px solid #1a2030',borderRadius:10}}>
                  <div style={{fontSize:12,fontWeight:700,color:'#c0c8d8',marginBottom:6}}>Montant simulé par trade ($)</div>
                  <div style={{fontSize:11,color:'#5a6a80',marginBottom:12,lineHeight:1.6}}>
                    Recalcule le PNL de tes trades sim avec ce montant. Laisse vide pour les valeurs réelles.
                  </div>
                  <div style={{display:'flex',gap:8}}>
                    <input type="number" placeholder="ex: 100" value={simAmountInput}
                      onChange={e => { setSimAmountInput(e.target.value); if (e.target.value) localStorage.setItem('sim-trade-amount', e.target.value); else localStorage.removeItem('sim-trade-amount'); }}
                      style={{...inp,flex:1}} />
                    <button onClick={() => { setSimAmountInput(''); localStorage.removeItem('sim-trade-amount'); }}
                      style={{padding:'10px 16px',borderRadius:6,background:'rgba(124,77,255,0.1)',border:'1px solid #7c4dff22',color:'#7c4dff',fontSize:12,fontWeight:700,cursor:'pointer',flexShrink:0}}>
                      Reset
                    </button>
                  </div>
                </div>

                {/* Reset historique */}
                <div style={{padding:'16px',background:'#0d1117',border:'1px solid #1a2030',borderRadius:10}}>
                  <div style={{fontSize:12,fontWeight:700,color:'#c0c8d8',marginBottom:6}}>Historique des trades sim</div>
                  <div style={{fontSize:11,color:'#5a6a80',marginBottom:12,lineHeight:1.6}}>
                    Efface tous les trades simulés de ton historique. Les trades live ne sont pas affectés.
                  </div>
                  <button onClick={handleClearSimHistory}
                    style={{padding:'10px',width:'100%',borderRadius:6,background:'rgba(255,107,107,0.08)',border:'1px solid #ff6b6b22',color:'#ff6b6b',fontSize:12,fontWeight:700,cursor:'pointer'}}>
                     Effacer l'historique sim
                  </button>
                </div>
              </div>
            )}{/*  TELEGRAM  */}
            {activeSection==='telegram'&&(
              <div style={{display:'flex',flexDirection:'column',gap:16}}>
                <div style={{fontSize:13,fontWeight:700,color:'#e0e8f0',marginBottom:4}}> Notifications Telegram</div>
                <div style={{padding:'12px 16px',background:tgToken&&tgChatId?'rgba(0,229,204,0.06)':'rgba(255,107,107,0.06)',border:`1px solid ${tgToken&&tgChatId?'#00e5cc22':'#ff6b6b22'}`,borderRadius:10,display:'flex',alignItems:'center',gap:10}}>
                  <span style={{fontSize:20}}>{tgToken&&tgChatId?'':''}</span>
                  <div>
                    <div style={{fontSize:12,fontWeight:700,color:tgToken&&tgChatId?'#00e5cc':'#ff6b6b'}}>{tgToken&&tgChatId?'Telegram configuré':'Non configuré'}</div>
                    <div style={{fontSize:10,color:'#3a4a5a',marginTop:2}}>{tgToken&&tgChatId?'Tu recevras des alertes pour chaque trade':'Configure ton bot Telegram ci-dessous'}</div>
                  </div>
                </div>
                <div style={{padding:'14px',background:'rgba(0,229,204,0.04)',border:'1px solid #00e5cc11',borderRadius:10}}>
                  <div style={{fontSize:11,fontWeight:700,color:'#00e5cc',marginBottom:8}}> Comment configurer</div>
                  <div style={{fontSize:11,color:'#8a9ab0',lineHeight:1.9}}>
                    <div><span style={{color:'#00e5cc',fontWeight:700}}>1.</span> Cherche <strong style={{color:'#00e5cc'}}>@BotFather</strong> sur Telegram</div>
                    <div><span style={{color:'#00e5cc',fontWeight:700}}>2.</span> Tape <code style={{background:'#0d1117',padding:'1px 6px',borderRadius:3,fontSize:10}}>/newbot</code> et suis les instructions</div>
                    <div><span style={{color:'#00e5cc',fontWeight:700}}>3.</span> Copie le token reçu dans le champ ci-dessous</div>
                    <div><span style={{color:'#00e5cc',fontWeight:700}}>4.</span> Envoie un message à ton bot puis récupère ton Chat ID</div>
                  </div>
                </div>
                <div style={{display:'flex',flexDirection:'column',gap:10}}>
                  <div>
                    <div style={{fontSize:10,color:'#5a6a80',marginBottom:6,letterSpacing:'0.8px'}}>TOKEN BOT TELEGRAM</div>
                    <input style={inp} placeholder="1234567890:AAFxK9m..."value={tgToken} onChange={e=>setTgToken(e.target.value)}/>
                  </div>
                  <div>
                    <div style={{fontSize:10,color:'#5a6a80',marginBottom:6,letterSpacing:'0.8px'}}>CHAT ID</div>
                    <input style={inp} placeholder="123456789"value={tgChatId} onChange={e=>setTgChatId(e.target.value)}/>
                  </div>
                  {tgMsg&&<div style={{fontSize:11,color:tgMsg.startsWith('')?'#00e5cc':'#ff6b6b',padding:'8px 10px',background:tgMsg.startsWith('')?'rgba(0,229,204,0.08)':'rgba(255,107,107,0.08)',borderRadius:6}}>{tgMsg}</div>}
                  <div style={{display:'flex',gap:8}}>
                    <button onClick={handleTestTelegram} disabled={tgLoading||!tgToken||!tgChatId}
                      style={{flex:1,padding:'10px',borderRadius:6,background:'rgba(124,77,255,0.15)',border:'1px solid #7c4dff33',color:'#7c4dff',fontSize:12,fontWeight:700,cursor:'pointer',opacity:!tgToken||!tgChatId?0.5:1}}>
                      {tgLoading?'⏳ Envoi...':'Tester'}
                    </button>
                    <button onClick={handleSaveTelegram} disabled={!tgToken||!tgChatId}
                      style={{flex:1,padding:'10px',borderRadius:6,background:'rgba(0,229,204,0.15)',border:'1px solid #00e5cc33',color:'#00e5cc',fontSize:12,fontWeight:700,cursor:'pointer',opacity:!tgToken||!tgChatId?0.5:1}}>
                       Sauvegarder
                    </button>
                  </div>
                  {tgToken&&tgChatId&&(
                    <button onClick={async()=>{await supabase.from('profiles').update({telegram_token:null,telegram_chat_id:null}).eq('id',user.id);if(onProfileUpdate)onProfileUpdate();setTgToken('');setTgChatId('');setTgMsg('Telegram supprimé');setTimeout(()=>setTgMsg(''),3000);}}
                      style={{padding:'8px',borderRadius:6,background:'rgba(255,107,107,0.08)',border:'1px solid #ff6b6b22',color:'#ff6b6b',fontSize:11,fontWeight:700,cursor:'pointer'}}>
                       Supprimer la configuration
                    </button>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}